import { createSelector } from '@reduxjs/toolkit';
import { selectFlatOldSaleTypeValue } from './selectFlatOldSaleTypeValue';
import { OTHERS_LIST } from './constants';

export const selectFlatOldSaleTypeFilter = createSelector([selectFlatOldSaleTypeValue], value => ({
  label: 'На вторичке',
  value,
  options: OTHERS_LIST,
}));
